module.exports = __webpack_public_path__ + "static/media/bg-sunglass.eed54bbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-sunglass.jpg
// module id = 491
// module chunks = 33